// packages/shared-hooks/src/leads/useCreateLead.ts
//
// `POST /leads` — manager-driven Lead create. Response carries the new
// `LeadListItem` plus an id-only `phoneDuplicates` array the UI uses to
// warn the manager about parallel rows on the same E.164 phone. Both list
// shapes (single + infinite) must refresh so the new row appears regardless
// of which filter is active.
import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
  CreateLeadResponseSchema,
  type CreateLeadInput,
  type CreateLeadResponse,
} from '@magimp/shared';
import { useApiClient } from '../api/context.js';
import { leadsKeys } from './keys.js';

export function useCreateLead() {
  const client = useApiClient();
  const qc = useQueryClient();
  return useMutation<CreateLeadResponse, unknown, CreateLeadInput>({
    mutationFn: (input) =>
      client.post<CreateLeadResponse>('/leads', input, {}, CreateLeadResponseSchema),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: leadsKeys.all });
    },
  });
}
